// You can write more code here

/* START OF COMPILED CODE */

import EntitySmashable from "../../EntitySmashable";
/* START-USER-IMPORTS */
import { CharacterSkins, CharacterSkinsValues } from '../../../CharacterSpine';
import { BodyTypes } from '../../LevelManager';
/* END-USER-IMPORTS */

export default class EntitySmashableCrate extends EntitySmashable {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 47, y ?? 128);

    // crate
    const crate = scene.add.image(0, 0, 'game-all', "smashable-crate.png");
    this.add(crate);

    // crate1
    const crate1 = scene.add.image(0, -84, 'game-all', "smashable-crate.png");
    this.add(crate1);

    // crate2
    const crate2 = scene.add.image(0, 84, 'game-all', "smashable-crate.png");
    this.add(crate2);

    // icon
    const icon = scene.add.image(0, 0, "game", "icon-grizz.png");
    this.add(icon);

    // icon1
    const icon1 = scene.add.image(0, -84, "game", "icon-grizz.png");
    this.add(icon1);

    // icon2
    const icon2 = scene.add.image(0, 84, "game", "icon-grizz.png");
    this.add(icon2);

    this.crate = crate;
    this.crate1 = crate1;
    this.crate2 = crate2;
    this.icon = icon;
    this.icon1 = icon1;
    this.icon2 = icon2;

    /* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
  }

  private crate: Phaser.GameObjects.Image;
  private crate1: Phaser.GameObjects.Image;
  private crate2: Phaser.GameObjects.Image;
  private icon: Phaser.GameObjects.Image;
  private icon1: Phaser.GameObjects.Image;
  private icon2: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  public reset(allowedCharacter?: CharacterSkinsValues) {
    super.reset(allowedCharacter);
    let iconCharacter = allowedCharacter ? allowedCharacter : this.allowedCharacter;

    this.icon.setFrame(EntitySmashableCrate.iconLookup.get(iconCharacter) ?? EntitySmashableCrate.defaultIcon);
    this.icon1.setFrame(EntitySmashableCrate.iconLookup.get(iconCharacter) ?? EntitySmashableCrate.defaultIcon);
    this.icon2.setFrame(EntitySmashableCrate.iconLookup.get(iconCharacter) ?? EntitySmashableCrate.defaultIcon);
  }

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    this.setSize(this.crate.displayWidth, this.crate.displayHeight * 3);

    super.injectMatter(target);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
